import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { getCountryList } from 'features/master-data/api/getCountryList';
import {
  masterDataKeys,
  masterDataStaleTime,
} from 'features/master-data/api/queryKeys';
import { useDebounce } from 'shared/hooks/useDebounce';

const useCountrySelect = ({ isEnabled }) => {
  const [countries, setCountries] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(50);
  const [hasMore, setHasMore] = useState(true);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 400);

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch]);

  const queryParams = { search: debouncedSearch, limit, page };

  const { isFetching: countryLoading } = useQuery(
    masterDataKeys.countries(queryParams),
    () => getCountryList(queryParams),
    {
      enabled: isEnabled,
      staleTime: masterDataStaleTime.BATCH,
      onSuccess: (res) => {
        const dataArr = Array.isArray(res?.data) ? res.data : [];
        const total = res?.meta?.total || 0;
        setCountries((prev) => (page === 1 ? dataArr : [...prev, ...dataArr]));
        setHasMore(page * limit < total);
      },
      onError: (e) => {
        toast.error(e?.response?.data?.errors?.[0]?.message || e.message);
      },
      keepPreviousData: true,
    }
  );

  const handleSearchCountry = (val) => {
    setSearch(val);
  };

  const handleScrollCountry = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (
      !countryLoading &&
      hasMore &&
      scrollTop + clientHeight >= scrollHeight - 10
    ) {
      setPage((p) => p + 1);
    }
  };

  return {
    countries,
    countryLoading,
    handleSearchCountry,
    handleScrollCountry,
  };
};

export default useCountrySelect;
